/**
 * Shared file-upload constants for feedback and bug-report modals.
 *
 * Previously duplicated verbatim in both FeedbackModal and ReportBugModal.
 * Any future modal that accepts user attachments should import from here.
 */

export const ACCEPTED_FILE_EXTENSIONS =
  ".jpg,.jpeg,.png,.gif,.pdf,.txt,.log,.csv,.zip,.json,.xml";

export const IMAGE_FILE_EXTENSIONS = new Set(["jpg", "jpeg", "png", "gif"]);

export const MAX_ATTACHMENT_MB = 10;

export const MAX_ATTACHMENT_BYTES = MAX_ATTACHMENT_MB * 1024 * 1024;
